<div class="flex items-center justify-center bg-gray-100">
  <div class="w-full bg-white rounded-lg shadow-l p-3 md:p-8 space-y-6">

    <div class="flex items-center justify-between mb-8">
      <h1 class="text-xl font-bold">Atti Amministrativi</h1>
    </div>

    <app-search-panel [searchFields]="searchPanelConfig" (searchParamChange)="onSearchParamChange($event)"></app-search-panel>

    @if(procedures$ | async; as procedures)  {
    <div class=" overflow-auto w-full cursor-pointer">
      <div class="md:shadow-lg md:bg-gray-50 rounded-xl md:border md:border-gray-200">
        <div class="mx-auto">

          <table class="w-full border-collapse block md:table">

            <thead class="block md:table-header-group">
            <tr class="absolute -top-full -left-full md:relative md:top-auto md:left-auto md:table-row block border-b border-gray-200 bg-gray-100/50">
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell">
                  <div class="table-header-row" (click)="setOrder('code')">Numero registrazione
                    @if (currentSort.field === 'code') {
                      <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;' }}</span>
                    }
                  </div>
              </th>
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell">
                <div class="table-header-row" (click)="setOrder('tags')">Linea
                @if(currentSort.field === 'tags') {
                  <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;'}}</span>
                }
              </div></th>
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell">
                <div class="table-header-row" (click)="setOrder('label')">Oggetto
                @if(currentSort.field === 'label') {
                  <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;'}}</span>
                }
              </div></th>
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell">
                <div class="table-header-row" (click)="setOrder('registration_date')">Data
                @if(currentSort.field === 'registration_date') {
                  <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;'}}</span>
                }
              </div></th>
            </tr>
            </thead>

            <tbody class="block md:table-row-group">
              @for (r of procedures; track r.id) {
            <tr (click)="onRowClicked(r.id)"
                class="bg-white block md:table-row mb-4 md:mb-0 rounded-2xl md:rounded-none border border-gray-100 md:border-b md:border-gray-200 shadow-sm md:shadow-none hover:bg-blue-50/30 transition-colors">

              <div class="flex flex-col p-5 md:p-0 md:contents">

                <div class="flex flex-col gap-3 md:contents">
                  <div class="flex justify-between items-start md:contents">

                    <td class="p-0 md:p-4 md:pl-4 block md:table-cell text-sm text-gray-600 font-medium md:font-normal py-1">
                      <span class="inline-block font-bold uppercase text-[10px] md:hidden text-gray-400">Numero registrazione</span>
                      {{ r.code }}
                    </td>

                    <td class="p-0 md:p-4 block md:table-cell text-right md:text-left">
                      <span class="py-1 text-xs font-semibold ">
                        @if(r.tags.length > 0) {
                          <span class="md:hidden">Linea:</span>
                        }
                        {{ r.tags.length > 0 && r.tags[0][1] || "" }}

                        @if(r.tags.length > 1 && r.tags[1][1]) {
                          {{ ", " + r.tags[1][1] }}
                          @if(r.tags.length > 2) {
                            <div class="relative inline-block group">
                              <u class="tag-to-hover cursor-pointer">
                                {{`+${(r.tags.length - 2)}` }}
                              </u>
                              <span class="absolute mt-1 top-full bg-[#004679] p-1 min-w-[68px] text-center rounded text-white left-1/2 -translate-x-1/2 mb-2 z-10
                                pointer-events-none opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-200 ease-out">
                                <svg class="absolute rotate-[-45deg] -top-[5px] size-3 left-1/2 -translate-x-1/2" viewBox="0 0 2 2">
                                  <polyline points="2,2 0,0 2,0" fill="#004679" stroke="#004679" stroke-width="1" vector-effect="non-scaling-stroke"/>
                                </svg>
                                <div class="flex flex-col">
                                  @for (tag of r.tags; let index = $index; let last = $last; track $index) {
                                    @if (index > 1 && index < r.tags.length) {
                                      <span class="text-xs font-semibold min-w-max px-3 py-2 ">{{ tag[1] | truncate}}</span>
                                      @if (!last) {
                                        <hr/>
                                      }
                                    }
                                  }
                                </div>
                              </span>

                            </div>
                          }
                        }
                      </span>
                    </td>

                  </div> <td class="p-0 md:p-4 md:pt-4 block md:table-cell text-lg md:text-sm font-bold md:font-medium text-gray-800">
                  {{ r.label | truncate }}
                </td>
                </div> <div class="flex justify-end items-end mt-5 pt-4 border-t border-gray-50 md:contents md:mt-0 md:pt-0 md:border-t-0">


                <div class="flex flex-col text-right md:contents md:text-left">
                  <td class="p-0 md:p-4 block md:table-cell text-sm text-gray-600 italic md:not-italic font-medium md:font-normal">
                    <span class="inline-block font-bold uppercase text-[10px] md:hidden text-gray-400">Data</span><br class="md:hidden">
                    {{ r.registration_date | date: 'dd/MM/yyyy HH:mm:ss' }}
                  </td>
                </div>

              </div> </div> </tr>
              } @empty {
                <div class="flex justify-center items-center h-24">
                  <h4 class="text-center absolute w-[300px] left-1/2 -translate-x-1/2">Nessun record trovato</h4>
                </div>
              }
            </tbody>
          </table>

        </div>
      </div>
      <app-pagination [params]="pagingParams" [totalItems]="totalRows" (pageChange)="goToPage($event)"></app-pagination>
    </div>
        }
    <div class="flex items-center justify-end mb-8">
      <button (click)="refresh()" class="button primary">
        <img class="inline align-sub" ngSrc="/icons/refresh.svg" alt="" height="20" width="20">
        Aggiorna Elenco
      </button>
    </div>



  </div>
</div>
